import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { QualityControlSetContainerModel } from "../../../../../../../models/aggregates/alg/cc/quality-control/quality-control-set-container.model";
import { BaseApiTemplateService } from "../../../shared/base-api-template-service.model";
import { Core2Config } from "../../../shared/core2Config";

@Injectable({
	providedIn: "root",
})
export class QualityControlSetService extends BaseApiTemplateService<QualityControlSetContainerModel> {
	readonly url =
		Core2Config.TENANT_DOMAIN_URL_PREFIX +
		Core2Config.ALG_CC_MODULE +
		"qc/sets";

	constructor(http: HttpClient) {
		super();
		this.apiUrl =
			Core2Config.DOMAIN_URL +
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.ALG_CC_MODULE +
			"qc/sets";
		this.endpoint_path =
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.ALG_CC_MODULE +
			"qc/sets";
		this.httpClient = http;
	}
}
